import React, { useState, useEffect } from 'react';
import { collection, query, where, getDocs, doc, updateDoc, setDoc } from 'firebase/firestore';
import { db } from '../../../firebaseConfig';
import styles from './IdCardApprovals.module.css';

const IdCardApprovals = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchApplications = async () => {
      setLoading(true);
      try {
        const q = query(collection(db, 'idCardApplications'), where('status', '==', 'pending'));
        const querySnapshot = await getDocs(q);
        const apps = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setApplications(apps);
      } catch (error) {
        console.error('Error fetching applications:', error);
      }
      setLoading(false);
    };

    fetchApplications();
  }, []);

  const handleApprove = async (appId, appData) => {
    try {
      const appDocRef = doc(db, 'idCardApplications', appId);
      await updateDoc(appDocRef, { status: 'approved' });

      const idCardRef = doc(db, 'idCards', appId);
      const { pictureUrl, studentId, ...restOfAppData } = appData;
      await setDoc(idCardRef, {
        ...restOfAppData,
        studentRegNumber: studentId, // Standardize to studentRegNumber
        photoUrl: pictureUrl,
        status: 'approved',
        issuedAt: new Date(),
      });

      setApplications(applications.filter(app => app.id !== appId));
      alert('Application approved!');
    } catch (error) {
      console.error('Error approving application:', error);
      alert('Failed to approve application.');
    }
  };

  const handleReject = async (appId) => {
    try {
      const appDocRef = doc(db, 'idCardApplications', appId);
      await updateDoc(appDocRef, { status: 'rejected' });
      
      setApplications(applications.filter(app => app.id !== appId));
      alert('Application rejected.');
    } catch (error) {
      console.error('Error rejecting application:', error);
      alert('Failed to reject application.');
    }
  };

  if (loading) {
    return <div className={styles.container}><p>Loading applications...</p></div>;
  }

  return (
    <div className={styles.container}>
      <h2>eID Card Applications for Approval</h2>
      {applications.length === 0 ? (
        <p>No pending applications.</p>
      ) : (
        <ul className={styles.appList}>
          {applications.map(app => (
            <li key={app.id} className={styles.appItem}>
              <div className={styles.appDetails}>
                <div className={styles.appInfo}>
                  <p><strong>Student:</strong> {app.name} ({app.studentId})</p>
                  <p><strong>Program:</strong> {app.program}</p>
                  <p><strong>SYS ID:</strong> {app.sysId}</p>
                  <p><strong>CNIC:</strong> {app.cnic}</p>
                  <p><strong>Session:</strong> {app.session}</p>
                </div>
                <div className={styles.appPicture}>
                  <img src={app.pictureUrl} alt="Student" />
                </div>
              </div>
              <div className={styles.appActions}>
                <button onClick={() => handleApprove(app.id, app)} className={styles.approveBtn}>Approve</button>
                <button onClick={() => handleReject(app.id)} className={styles.rejectBtn}>Reject</button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default IdCardApprovals;
